/* Before/After Comparison slider
   Put this file in your theme's /assets folder as:
   section-before-after-comparison.js

   Dragging is handled with pointer events directly on the image
   container instead of relying on the native <input type="range">
   drag behavior. Some themes apply global CSS/JS to range inputs
   (custom sliders, quantity steppers, price filters, etc.) which can
   block or break native range dragging. Driving the drag ourselves
   avoids that conflict entirely. The hidden range input is kept only
   so the slider stays keyboard-accessible (Tab + Arrow keys).
*/
(function () {
  function initSlider(sliderEl) {
    var wrap = sliderEl.querySelector('.dr-compare-image-wrap');
    var range = sliderEl.querySelector('[data-dr-compare-range]');
    var after = sliderEl.querySelector('[data-dr-compare-after]');
    var handle = sliderEl.querySelector('[data-dr-compare-handle]');

    if (!wrap || !range || !after || !handle) return;
    if (wrap.getAttribute('data-dr-compare-bound') === 'true') return;
    wrap.setAttribute('data-dr-compare-bound', 'true');

    var dragging = false;

    function setValue(value) {
      var v = Math.min(100, Math.max(0, value));
      after.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      handle.style.left = v + '%';
      range.value = v;
    }

    function valueFromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = clientX - rect.left;
      if (rect.width === 0) return parseFloat(range.value);
      return (x / rect.width) * 100;
    }

    function startDrag(clientX, pointerId) {
      dragging = true;
      if (pointerId != null && wrap.setPointerCapture) {
        try { wrap.setPointerCapture(pointerId); } catch (err) {}
      }
      setValue(valueFromClientX(clientX));
    }

    function moveDrag(clientX) {
      if (!dragging) return;
      setValue(valueFromClientX(clientX));
    }

    function endDrag() {
      dragging = false;
    }

    // Pointer Events cover mouse, touch and pen in one API on modern browsers.
    if (window.PointerEvent) {
      wrap.addEventListener('pointerdown', function (e) {
        startDrag(e.clientX, e.pointerId);
        e.preventDefault();
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        moveDrag(e.clientX);
        e.preventDefault();
      });
      wrap.addEventListener('pointerup', endDrag);
      wrap.addEventListener('pointercancel', endDrag);
    } else {
      // Fallback for older browsers without Pointer Events support.
      wrap.addEventListener('mousedown', function (e) {
        startDrag(e.clientX, null);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        moveDrag(e.clientX);
      });
      document.addEventListener('mouseup', endDrag);

      wrap.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) startDrag(e.touches[0].clientX, null);
      }, { passive: true });
      wrap.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) moveDrag(e.touches[0].clientX);
      }, { passive: true });
      wrap.addEventListener('touchend', endDrag);
      wrap.addEventListener('touchcancel', endDrag);
    }

    // Keyboard accessibility: focusing the hidden range input and
    // using Arrow Left/Right still works and stays in sync.
    range.addEventListener('input', function (e) {
      setValue(parseFloat(e.target.value));
    });

    setValue(parseFloat(range.value));
  }

  function initAll() {
    document.querySelectorAll('[data-dr-compare-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a merchant adds/reorders the section in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('[data-dr-compare-slider]');
    if (slider) initSlider(slider);
  });
})();